import React from 'react';
import { Tabs } from 'antd';
import type { TabsProps } from 'antd';
import s from './s.module.less';
import PageManagement from './components/PageManagement';
import StateManagement from './components/StateManagement';
import { PermissionModuleKeys } from 'constants/access';
import AccessDenied from 'components/AccessDenied';
import AccessStore from 'store/Access/permission';
import { getUrlParam, insertUrlParam } from 'utils/common';

export enum EType {
    WORKFLOWS = 'workflows',
    STATE_MANAGEMENT = 'stateManagement',
}

const EmbeddableWorkflowsPage = () => {
    const [getAccessStore] = AccessStore.useStore();
    const access = getAccessStore('data');

    // Tab state management
    const activeType = getUrlParam('type') as EType;
    const [type, setType] = React.useState(activeType || EType.WORKFLOWS);

    React.useEffect(() => {
        if (activeType) {
            setType(activeType);
        }
    }, [activeType]);

    const items: TabsProps['items'] = [
        {
            key: EType.WORKFLOWS,
            label: <p className={s.tabTitle}>Workflows</p>,
            children: access?.[PermissionModuleKeys.TEXT_VISIT_WORKFLOWS] ? (
                <PageManagement />
            ) : (
                <AccessDenied />
            ),
            forceRender: true,
        },
        {
            key: EType.STATE_MANAGEMENT,
            label: <p className={s.tabTitle}>State management</p>,
            children: access?.[PermissionModuleKeys.TEXT_VISIT_STATE_MANAGEMENT] ? (
                <StateManagement />
            ) : (
                <AccessDenied />
            ),
            forceRender: true,
        },
    ];

    return (
        <div className={s.wrap}>
            <div className={s.content}>
                {access?.[PermissionModuleKeys.KLARITY_ASSESSMENT] ? (
                    <div>
                        <h3 className={s.subtitle}>Embeddable workflows</h3>
                        <Tabs
                            activeKey={type}
                            items={items}
                            onChange={(key) => {
                                setType(key as EType);
                                insertUrlParam('type', key);
                            }}
                        />
                    </div>
                ) : (
                    <AccessDenied />
                )}
            </div>
        </div>
    );
};

export default EmbeddableWorkflowsPage;
